// extracted by mini-css-extract-plugin
module.exports = {"Topic":"Topic-3e2_54Vb"};